import React from 'react'

const doc = {
  title: '5 Benefits of .PAT Files',
  slug: 'five-benefits-of-pat-files',
  tags: ['education'],
  category: 'pat-file-basics',
  content: (props) => {
    return <div>
      <p className="p-push-down">With just a small amount of data, pattern files (.PAT) automatically create infinitely repeating vector line patterns in CAD programs. This can help save time, be more accurate, and keep a smaller file size. In general, any repeating line work within your document set or presentation drawings - whether it’s a steel hatch or brick coursework - should be a .PAT file for maximum efficiency. </p>

      <h5>1. Saving time</h5>
      <p className="p-push-down">
        Instead of spending countless hours offsetting lines, trimming lines, creating blocks and copying them across the file (and other various work arounds) - creating a .PAT file definition will allow you to quickly set a few parameters and have the program automatically draw the pattern for you. Need that pattern in another drawing or place? Once you've got the right .PAT file, you can leverage it again and again. 
      </p>

      <h5>2. Smaller file sizes</h5>
      <p className="p-push-down">
        Without .PAT files, many offices struggle to create blocks nested in other blocks - or even just drawing the line work manually - to create repeating patterns. Both of these cause more geometry to live in the file. A .PAT file definition only needs to be loaded once for your CAD program to automatically draws lines - without any more geometry. This drastically can reduce file size and improve performance of your CAD software.
      </p>

      <h5>3. Guaranteed accuracy</h5>
      <p className="p-push-down">
        Manually drawing patterns, offsetting lines, or copying blocks means there is a human element to drawing the pattern. Especially with complex and angled patterns, errors can happen that can take hours to track down or fix. With a PAT file, by definition it is going to be accurate no matter what. 
      </p>

      
      <h5>4. Easy team-wide standards</h5>
      <p className="p-push-down">
        Having a PAT definition saved for a particular pattern allows team members across your firm to reference the same file and sleep tight knowing that the pattern will be standard across all drawings. This means steel will look like steel whether on project #001 or #100. 
      </p>

      
      <h5>5. Easily modifiable</h5>
      <p className="p-push-down">
        .PAT files are easily updatable without having to extend, trim, or copy new blocks. You won’t need to XCLIP the block or worry about remembering to update the pattern. The pattern will automatically be generated globally across the drawing as defined by the .PAT file - saving you time and money.
      </p>

    
    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/five-benefits-of-pat-files.js